module.exports = __webpack_public_path__ + "static/media/first-promoter-logo.ce8b5219.bin";